import { useNode } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import type { Sponsor } from "src/types";

import SettingsTitleWrapper from "@/components/editor/shared/settings-title-wrapper";

import sponsorsTooltipPreview from "./sponsors-tooltip-preview.jpg";

export default function SponsorCardSettings() {
  const { props } = useNode((node) => {
    return {
      props: node.data.props as { sponsor: Sponsor },
    };
  });
  const { sponsor } = props;
  const { t } = useTranslation();

  return (
    <SettingsTitleWrapper
      title={t("preference-panel.sponsor")}
      tooltip={{
        description: `${t("preference-panel.sponsors.navigate-to-sponsors")}`,
        image: sponsorsTooltipPreview,
      }}
    >
      <p className="mb-2 text-xs font-medium text-gray-700">
        {t("preference-panel.sponsors.sponsor-picture")}
      </p>
      <img
        src={sponsor.image_url}
        alt={sponsor.name}
        className="mb-4 h-[4.375rem] w-28 rounded border border-solid border-gray-300 object-contain"
      />
      <p className="mb-2 text-xs font-medium text-gray-700">
        {t("preference-panel.sponsors.sponsor-name")}
      </p>
      <p className="mb-6 text-sm font-medium leading-6 text-gray-800">
        {sponsor.name}
      </p>
      <p className="mb-2 text-xs font-medium text-gray-700">
        {t("common.link")}
      </p>
      <a
        aria-label="sponsor-website"
        href={sponsor.website}
        target="_blank"
        rel="noreferrer"
        className="text-sm leading-none text-blue-400 no-underline"
      >
        {sponsor.website}
      </a>
    </SettingsTitleWrapper>
  );
}
